import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Client } from '@/api/profile';
import { profileColor, profileAbb } from '@/api/graphicIdentifier';
import REQ_URL from '@/consts/req-url';

@Component({
})
export default class ClientInfo extends Vue {
    @Prop() profile!: Client
    generatingNewPass = false
    get profileColor() {
        return profileColor(this.profile.fio)
    }
    get profileAbb() {
        return profileAbb(this.profile.fio)
    }

    async autoGenerateNewPass() {
        this.generatingNewPass = true
        try {
            let data = await this.$fetch<undefined | null>(REQ_URL.GEN_PASS, {
                method: 'POST',
                body: JSON.stringify({
                    cid: this.$route.params.cid
                })
            })
            if (data.msg) {
                this.$store.commit('modal:open', {
                    type: 'success',
                    msg: data.msg
                })
            }
            else throw new Error(data.error)
        } catch (error) {
            this.$store.commit('modal:open', {
                type: 'error',
                msg: error.message
            })
            console.error(error.message)
        }
        this.generatingNewPass = false
    }
}